/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AnotherPatient/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromFormat from 'Data/format.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function AnotherPatient({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Content/Receivables/Content/Expanded/Content/Content/Entry/EntryType/TransferCharge/AnotherPatient"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let patientIdValueData = fromData.useDataValue({ viewPath,
context: 'patient',
path: 'id',
})
let entryTransactionTransferChargeChargeTransferAdjustmentTransactionReceivablePatientIdValueData = fromData.useDataFormat({ viewPath,
context: 'entry',
path: 'transaction.transfer_charge.charge_transfer_adjustment.transaction.receivable.patient.id',
format: fromFormat.not,
})
let aggregateData = fromAggregate.equals(patientIdValueData, entryTransactionTransferChargeChargeTransferAdjustmentTransactionReceivablePatientIdValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}